import { Component, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-principal',
  templateUrl: './principal.component.html',
  styleUrls: ['./principal.component.scss'],
})
export class PrincipalComponent implements OnInit {
  @Output() eixos: [];
  catalogo: any;
  error = false;

  constructor(private route: ActivatedRoute) { }

  ngOnInit(): void {
    const routeData = this.route.snapshot.data.catalogo;
    this.error = routeData.error ? true : false;

    if (!routeData.error) {
      this.catalogo = routeData.catalogo;
      this.eixos = routeData.eixos.sort((eixo1: any, eixo2: any) => {
        return this.OrdenaEixos(eixo1, eixo2);
      });
    }
  }

  OrdenaEixos(eixo1: any, eixo2: any) {
    if (
      eixo1.nome.replace(/Eixo\sd?e?\s?(.*?)/, '$1').toLowerCase() <
      eixo2.nome.replace(/Eixo\sd?e?\s?(.*?)/, '$1').toLowerCase()
    ) {
      return -1;
    }
    if (eixo1.nome.toLowerCase() > eixo2.nome.toLowerCase()) {
      return 1;
    }
    return 0;
  }
}
